import { render, staticRenderFns } from "./MenuGestionePreventivi.vue?vue&type=template&id=6b243938&scoped=true&"
import script from "./MenuGestionePreventivi.vue?vue&type=script&lang=js&"
export * from "./MenuGestionePreventivi.vue?vue&type=script&lang=js&"
import style0 from "./MenuGestionePreventivi.vue?vue&type=style&index=0&id=6b243938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b243938",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList,QItem,QItemSection,QItemLabel});
